module.exports = __webpack_public_path__ + "static/media/calendar.768e9539.svg";